<app-page-header title="Kapcsolat"></app-page-header>

<div class="content my-5 col-lg-10 mx-auto">
  <div class="row contact-container p-5 p-5">
    <div class="col-md-6">
      <div class="row mb-5">
        <div class="col-lg-12 text-ceter h3 font-weight-bold">
          Elérhetőségek
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-2">Cím:</div>
        <div class="col-lg-8">2897 Dunaszentmiklós, Petőfi u. 52.</div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-2">Telefon:</div>
        <div class="col-lg-8">+36 34 491-819</div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-2">Telefon:</div>
        <div class="col-lg-8">+36 34 591-033</div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-2">Fax:</div>
        <div class="col-lg-8">+36 34 491-819</div>
      </div>
      <div class="row">
        <div class="col-lg-2">E-mail:</div>
        <div class="col-lg-8">ph@dunaszentmiklos.hu</div>
      </div>
      <div class="row mt-5">
        <div class="col-12 text-ceter h3 font-weight-bold">
          Ügyfélfogadási rend
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2">Hétfő</div>
        <div class="col-lg-10">8:00 - 12:00 és 13:00 - 16:00</div>
      </div>
      <div class="row">
        <div class="col-lg-2">Szerda</div>
        <div class="col-lg-10">13:00 - 15:30</div>
      </div>
      <div class="row">
        <div class="col-lg-2">Péntek</div>
        <div class="col-lg-10 ">8:00 - 12:00</div>
      </div>
    </div>
    <div class="col-md-6">
      <img src="./assets/imgs/map.PNG" />
    </div>
  </div>
</div>
